// test1456
(1456 && 0);
